export const DEFAULT = 'DEFAULT';

const getStorageKey = (keyName: string) => `SELLER_FORUMS_${keyName}`;

const getUserConfig = (id?: string) => {
  if (typeof window === 'undefined') return {};
  const storageKey = getStorageKey(id || DEFAULT);
  const userConfigString = localStorage.getItem(storageKey);
  try {
    const userConfig = JSON.parse(userConfigString || '{}');
    return userConfig;
  } catch {
    return {};
  }
};

export const updateConfig = (fieldName: string, value: string, id?: string) => {
  if (typeof window === 'undefined') return;
  const currentUserConfig = getUserConfig(id);
  const storageKey = getStorageKey(id || DEFAULT);
  const updatedUserConfig = {
    ...currentUserConfig,
    [fieldName]: value,
  };
  localStorage.setItem(storageKey, JSON.stringify(updatedUserConfig));
};

export function getConfigValue<Type>(
  fieldName: string,
  isValid: (configValue: Type) => boolean,
  id?: string,
): Type | undefined {
  const configValue = getUserConfig(id)[fieldName];
  if (!isValid(configValue)) {
    return undefined;
  }
  return configValue as Type;
}
